import {HarbourDuesContainerClass} from "@portbase/bezoekschip-service-typescriptmodels";

export const HARBOUR_DUES_CONTAINER_CLASSES: readonly HarbourDuesContainerClass[] = [
  HarbourDuesContainerClass.FT_20_29,
  HarbourDuesContainerClass.FT_30_39,
  HarbourDuesContainerClass.FT_40_44,
  HarbourDuesContainerClass.FT_45_PLUS,
];

export const HARBOUR_DUES_CONTAINER_CLASS_DESCRIPTIONS: Record<HarbourDuesContainerClass, string> = {
  [HarbourDuesContainerClass.FT_20_29]: '20-29ft',
  [HarbourDuesContainerClass.FT_30_39]: '30-39ft',
  [HarbourDuesContainerClass.FT_40_44]: '40-44ft',
  [HarbourDuesContainerClass.FT_45_PLUS]: '45ft and more',
};

export function formatContainerClass(containerClass: HarbourDuesContainerClass): string {
  return HARBOUR_DUES_CONTAINER_CLASS_DESCRIPTIONS[containerClass] ?? '';
}
